import {useRootStore} from '@/store/index.js'
import {showWarnMessage} from '@/util/message.js'
import {isNavigationFailure, NavigationFailureType} from 'vue-router'

export async function pushRoute(url, router) {
    try {
        await router.push(url)
    } catch (failure) {
        if (isNavigationFailure(failure, NavigationFailureType.duplicated)) {
            console.log('duplicated')
            return
        }

        if (isNavigationFailure(failure, NavigationFailureType.redirected)) {
            console.log('redirected')
            return
        }
        console.error(failure)
    }
}

export function pushWindow(url, router) {
    const routeData = router.resolve(url)
    window.open(routeData.href)
}

export function pushExternalWindow(url) {
    window.open(url)
}

export function pushLogin(pushCallback) {
    const store = useRootStore()
    store.setUserInfo({})
    pushCallback()
    showWarnMessage('当前未登录，跳转到登录页面')
}
